import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, memo, useState } from 'react';
import SpectraPanelHeader from './SpectraPanelHeader';
import SpectrumsTabs from './SpectrumsTabs';
const styles = {
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
};
function SpectrumListPanel() {
    const [spectra, setSpectra] = useState([]);
    const tabChangeHandler = useCallback((e) => {
        setSpectra(e.data || []);
    }, []);
    return (_jsxs("div", { style: styles, children: [_jsx(SpectraPanelHeader, { spectrums: spectra }), _jsx(SpectrumsTabs, { onTabChange: tabChangeHandler })] }));
}
export default memo(SpectrumListPanel);
